/* ═══════════════════════════════════════════════════════════
   DAFFI Barcelona — Main JavaScript v2.0
   Theme completo editable por bloques para Shopify OS 2.0
   ═══════════════════════════════════════════════════════════ */

(function() {
  'use strict';

  /* ─── UTILITIES ─── */
  const $ = (sel, ctx = document) => ctx.querySelector(sel);
  const $$ = (sel, ctx = document) => [...ctx.querySelectorAll(sel)];

  function debounce(fn, delay = 250) {
    let timer;
    return (...args) => { clearTimeout(timer); timer = setTimeout(() => fn(...args), delay); };
  }

  function formatMoney(cents) {
    const format = window.DAFFI?.store?.moneyFormat || '€{{amount_with_comma_separator}}';
    return format
      .replace('{{amount_with_comma_separator}}', (cents / 100).toFixed(2).replace('.', ','))
      .replace('{{amount}}', (cents / 100).toFixed(2));
  }

  function fetchJSON(url, options = {}) {
    return fetch(url, {
      ...options,
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', ...options.headers }
    }).then(r => r.json());
  }

  /* ═══════════════════════════════════════
     ANNOUNCEMENT BAR
     ═══════════════════════════════════════ */
  function initAnnouncementBar() {
    const bar = $('[data-announce-prev]')?.closest('.announce-bar');
    if (!bar) return;

    const msgs = $$('.announce-bar__msg', bar);
    if (msgs.length <= 1) return;

    let current = 0;
    let interval;

    function show(index) {
      msgs.forEach(m => m.classList.remove('active'));
      msgs[index].classList.add('active');
    }

    function next() {
      current = (current + 1) % msgs.length;
      show(current);
    }

    function prev() {
      current = (current - 1 + msgs.length) % msgs.length;
      show(current);
    }

    function startAutoplay() {
      const speed = parseInt(bar.closest('[data-shopify-editor-section]')?.dataset?.speed || '4') * 1000;
      interval = setInterval(next, speed > 0 ? speed : 4000);
    }

    function stopAutoplay() { clearInterval(interval); }

    const prevBtn = $('[data-announce-prev]', bar);
    const nextBtn = $('[data-announce-next]', bar);
    const closeBtn = $('[data-announce-close]', bar);

    if (prevBtn) prevBtn.addEventListener('click', () => { stopAutoplay(); prev(); startAutoplay(); });
    if (nextBtn) nextBtn.addEventListener('click', () => { stopAutoplay(); next(); startAutoplay(); });
    if (closeBtn) closeBtn.addEventListener('click', () => { bar.style.display = 'none'; });

    startAutoplay();
  }

  /* ═══════════════════════════════════════
     HEADER — Sticky + Transparent
     ═══════════════════════════════════════ */
  function initHeader() {
    const header = $('[data-header]');
    if (!header) return;

    let lastScroll = 0;

    function onScroll() {
      const scrollY = window.scrollY;
      if (scrollY > 50) {
        header.classList.add('scrolled');
      } else {
        header.classList.remove('scrolled');
      }
      lastScroll = scrollY;
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ═══════════════════════════════════════
     MEGA MENU — Accessibility (aria-expanded)
     ═══════════════════════════════════════ */
  function initMegaMenuAccessibility() {
    $$('.main-nav__item').forEach(item => {
      const trigger = $('.main-nav__link', item);
      if (!trigger) return;

      item.addEventListener('mouseenter', () => {
        trigger.setAttribute('aria-expanded', 'true');
      });
      item.addEventListener('mouseleave', () => {
        trigger.setAttribute('aria-expanded', 'false');
      });

      // Also handle keyboard focus within the mega-menu
      item.addEventListener('focusin', () => {
        trigger.setAttribute('aria-expanded', 'true');
      });
      item.addEventListener('focusout', (e) => {
        // Only close if focus moves outside the entire nav item
        if (!item.contains(e.relatedTarget)) {
          trigger.setAttribute('aria-expanded', 'false');
        }
      });
    });
  }

  /* ═══════════════════════════════════════
     MOBILE MENU
     ═══════════════════════════════════════ */
  function initMobileMenu() {
    const menu = $('[data-mobile-menu]');
    const overlay = $('[data-menu-overlay]');
    if (!menu) return;

    function open() {
      menu.classList.add('open');
      if (overlay) overlay.classList.add('open');
      document.body.style.overflow = 'hidden';
      const hamburger = $('[data-mobile-menu-open]');
      if (hamburger) hamburger.setAttribute('aria-expanded', 'true');
    }

    function close() {
      menu.classList.remove('open');
      if (overlay) overlay.classList.remove('open');
      document.body.style.overflow = '';
      const hamburger = $('[data-mobile-menu-open]');
      if (hamburger) hamburger.setAttribute('aria-expanded', 'false');
    }

    $$('[data-mobile-menu-open]').forEach(btn => btn.addEventListener('click', open));
    $$('[data-mobile-menu-close]').forEach(btn => btn.addEventListener('click', close));
    if (overlay) overlay.addEventListener('click', close);

    // Close on escape
    document.addEventListener('keydown', e => {
      if (e.key === 'Escape' && menu.classList.contains('open')) close();
    });
  }

  /* ═══════════════════════════════════════
     SEARCH OVERLAY
     ═══════════════════════════════════════ */
  function initSearch() {
    const overlay = $('[data-search-overlay]');
    if (!overlay) return;

    function open() {
      overlay.classList.add('open');
      document.body.style.overflow = 'hidden';
      const input = $('input', overlay);
      if (input) setTimeout(() => input.focus(), 200);
    }

    function close() {
      overlay.classList.remove('open');
      document.body.style.overflow = '';
    }

    $$('[data-search-open]').forEach(btn => btn.addEventListener('click', open));
    $$('[data-search-close]').forEach(btn => btn.addEventListener('click', close));

    overlay.addEventListener('click', e => {
      if (e.target === overlay) close();
    });

    document.addEventListener('keydown', e => {
      if (e.key === 'Escape' && overlay.classList.contains('open')) close();
    });
  }

  /* ═══════════════════════════════════════
     CART DRAWER
     ═══════════════════════════════════════ */
  function initCartDrawer() {
    const drawer = $('[data-cart-drawer]');
    const overlay = $('[data-cart-overlay]');
    if (!drawer) return;

    function open() {
      drawer.classList.add('open');
      if (overlay) overlay.classList.add('open');
      document.body.style.overflow = 'hidden';
    }

    function close() {
      drawer.classList.remove('open');
      if (overlay) overlay.classList.remove('open');
      document.body.style.overflow = '';
    }

    $$('[data-cart-open]').forEach(btn => btn.addEventListener('click', e => {
      e.preventDefault();
      open();
    }));
    $$('[data-cart-close]').forEach(btn => btn.addEventListener('click', close));
    if (overlay) overlay.addEventListener('click', close);

    document.addEventListener('keydown', e => {
      if (e.key === 'Escape' && drawer.classList.contains('open')) close();
    });

    // Quantity changes in cart drawer
    $$('[data-qty-change]', drawer).forEach(btn => {
      btn.addEventListener('click', () => {
        const key = btn.dataset.qtyChange;
        const dir = parseInt(btn.dataset.qtyDir);
        const input = $(`[data-qty-input="${key}"]`, drawer);
        if (!input) return;
        const newQty = Math.max(0, parseInt(input.value) + dir);
        updateCartItem(key, newQty);
      });
    });

    // Remove items
    $$('[data-remove-item]', drawer).forEach(btn => {
      btn.addEventListener('click', () => {
        updateCartItem(btn.dataset.removeItem, 0);
      });
    });

    // Make open/close globally available
    window.openCartDrawer = open;
    window.closeCartDrawer = close;
  }

  /* ─── Cart API ─── */
  function updateCartItem(key, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
    .then(r => r.json())
    .then(cart => {
      updateCartUI(cart);
      return cart;
    })
    .catch(err => console.error('Cart update error:', err));
  }

  function updateCartUI(cart) {
    // Global counts and totals
    $$('[data-cart-count]').forEach(el => { el.textContent = cart.item_count; });
    $$('[data-cart-count-label]').forEach(el => {
      el.textContent = `(${cart.item_count} artículos)`;
    });
    const total = formatMoney(cart.total_price);
    $$('[data-cart-total]').forEach(el => { el.textContent = total; });

    // Update drawer items (quantities, prices)
    const drawer = $('[data-cart-drawer]');
    if (drawer) {
      cart.items.forEach(item => {
        const el = $(`[data-cart-item="${item.key}"]`, drawer);
        if (!el) return;
        const qtyVal = $('.cart-qty-val', el);
        const qtyInput = $(`[data-qty-input="${item.key}"]`, drawer);
        const priceEl = $(`[data-item-price="${item.key}"]`, drawer);
        const origEl = $(`[data-item-orig="${item.key}"]`, drawer);
        if (qtyVal) qtyVal.textContent = item.quantity;
        if (qtyInput) qtyInput.value = item.quantity;
        if (priceEl) priceEl.textContent = formatMoney(item.final_line_price);
        if (origEl) {
          if (item.original_line_price > item.final_line_price) {
            origEl.textContent = formatMoney(item.original_line_price);
            origEl.style.display = '';
          } else {
            origEl.style.display = 'none';
          }
        }
      });

      // Remove items no longer in cart
      $$('[data-cart-item]', drawer).forEach(el => {
        const key = el.dataset.cartItem;
        if (!cart.items.find(i => i.key === key)) el.remove();
      });

      // Update discount display in drawer
      const discountEl = $('[data-cart-discount]', drawer);
      if (discountEl) {
        if (cart.total_discount > 0) {
          discountEl.textContent = '-' + formatMoney(cart.total_discount);
          discountEl.closest('[data-cart-discount-row]').style.display = 'flex';
        } else {
          discountEl.closest('[data-cart-discount-row]').style.display = 'none';
        }
      }

      if (cart.item_count === 0) window.location.reload();
    }
  }

  /* ─── Quick Add to Cart ─── */
  window.quickAddToCart = function(variantId, element) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
    .then(r => r.json())
    .then(() => {
      // Refresh cart count
      fetch('/cart.js')
        .then(r => r.json())
        .then(cart => {
          updateCartUI(cart);
          if (window.openCartDrawer) window.openCartDrawer();
        });
    })
    .catch(err => console.error('Quick add error:', err));
  };

  /* ─── Wishlist (localStorage) ─── */
  window.toggleWishlist = function(btn, productId) {
    let wishlist = JSON.parse(localStorage.getItem('daffi_wishlist') || '[]');
    const index = wishlist.indexOf(productId);

    if (index > -1) {
      wishlist.splice(index, 1);
      btn.classList.remove('active');
      btn.querySelector('svg').style.fill = 'none';
    } else {
      wishlist.push(productId);
      btn.classList.add('active');
      btn.querySelector('svg').style.fill = 'currentColor';
    }

    localStorage.setItem('daffi_wishlist', JSON.stringify(wishlist));
  };

  /* Load wishlist state */
  function loadWishlistState() {
    const wishlist = JSON.parse(localStorage.getItem('daffi_wishlist') || '[]');
    $$('.product-card__wishlist').forEach(btn => {
      const card = btn.closest('[data-product-id]');
      if (card) {
        const id = parseInt(card.dataset.productId);
        if (wishlist.includes(id)) {
          btn.classList.add('active');
          btn.querySelector('svg').style.fill = 'currentColor';
        }
      }
    });

    /* Bind click handlers to wishlist buttons */
    $$('.product-card__wishlist').forEach(btn => {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        const productId = this.dataset.productId;
        if (productId) window.toggleWishlist(this, parseInt(productId));
      });
    });
  }

  /* ═══════════════════════════════════════
     HERO — Sport Tabs
     ═══════════════════════════════════════ */
  function initHeroTabs() {
    const tabs = $$('[data-hero-tab]');
    if (tabs.length === 0) return;

    const heroImg = $('.hero__bg-img');

    tabs.forEach(tab => {
      tab.addEventListener('click', () => {
        tabs.forEach(t => t.classList.remove('active'));
        tab.classList.add('active');

        const imgUrl = tab.dataset.heroImg;
        if (imgUrl && heroImg) {
          heroImg.style.opacity = '0';
          setTimeout(() => {
            heroImg.src = imgUrl;
            heroImg.style.opacity = '1';
          }, 300);
        }
      });
    });
  }

  /* ═══════════════════════════════════════
     PRODUCT GALLERY
     ═══════════════════════════════════════ */
  function initProductGallery() {
    const gallery = $('[data-product-gallery]');
    if (!gallery) return;

    const slides = $$('[data-gallery-slide]', gallery);
    const thumbs = $$('[data-gallery-thumb]');

    function showSlide(index) {
      slides.forEach(s => s.classList.remove('active'));
      thumbs.forEach(t => t.classList.remove('active'));
      if (slides[index]) slides[index].classList.add('active');
      if (thumbs[index]) thumbs[index].classList.add('active');
    }

    thumbs.forEach(thumb => {
      thumb.addEventListener('click', () => {
        showSlide(parseInt(thumb.dataset.galleryThumb));
      });
    });
  }

  /* ═══════════════════════════════════════
     PRODUCT VARIANT SELECTOR
     ═══════════════════════════════════════ */
  function initVariantSelector() {
    const form = $('[data-product-form]');
    if (!form || form.dataset.variantHandledInline) return; // Skip if handled by inline script

    const optionBtns = $$('.main-product__option-btn', form);
    const variantInput = $('[data-variant-id]', form);
    const addBtn = $('[data-add-to-cart]', form);

    optionBtns.forEach(btn => {
      btn.addEventListener('click', () => {
        const name = btn.dataset.optionName;
        $$(`[data-option-name="${name}"]`, form).forEach(b => b.classList.remove('active'));
        btn.classList.add('active');

        // Update variant — simplified version
        // In production, this would lookup variant JSON
        updateSelectedVariant();
      });
    });

    function updateSelectedVariant() {
      // This is a simplified version
      // A full implementation would use product.variants JSON to find matching variant
      const selectedOptions = {};
      $$('.main-product__option', form).forEach(optGroup => {
        const label = $('label', optGroup)?.textContent.trim();
        const activeBtn = $('.main-product__option-btn.active', optGroup);
        if (label && activeBtn) {
          selectedOptions[label] = activeBtn.dataset.optionValue;
        }
      });
    }
  }

  /* ═══════════════════════════════════════
     QUANTITY BUTTONS (General)
     ═══════════════════════════════════════ */
  function initQuantityBtns() {
    $$('[data-qty-minus]').forEach(btn => {
      btn.addEventListener('click', () => {
        const input = btn.closest('.qty-selector')?.querySelector('.qty-val');
        if (input) input.value = Math.max(1, parseInt(input.value) - 1);
      });
    });

    $$('[data-qty-plus]').forEach(btn => {
      btn.addEventListener('click', () => {
        const input = btn.closest('.qty-selector')?.querySelector('.qty-val');
        if (input) input.value = parseInt(input.value) + 1;
      });
    });
  }

  /* ═══════════════════════════════════════
     FILTER TABS (Featured Products)
     ═══════════════════════════════════════ */
  function initFilterTabs() {
    $$('[data-filter-tabs]').forEach(tabContainer => {
      const tabs = $$('.filter-tab', tabContainer);
      const grid = tabContainer.closest('section')?.querySelector('.featured-products__grid');
      if (!grid) return;

      tabs.forEach(tab => {
        tab.addEventListener('click', () => {
          tabs.forEach(t => t.classList.remove('active'));
          tab.classList.add('active');
          // In a Shopify context, this would filter by product tag
          // Placeholder animation
          grid.style.opacity = '0.5';
          setTimeout(() => { grid.style.opacity = '1'; }, 300);
        });
      });
    });
  }

  /* ═══════════════════════════════════════
     COLLECTION FILTERS TOGGLE (Mobile)
     ═══════════════════════════════════════ */
  function initFiltersToggle() {
    const toggleBtn = $('[data-filters-toggle]');
    if (!toggleBtn) return;

    const sidebar = $('[data-collection-filters]');
    if (!sidebar) return;

    toggleBtn.addEventListener('click', () => {
      const isOpen = sidebar.classList.toggle('filters--open');
      toggleBtn.setAttribute('aria-expanded', isOpen);
      // On mobile, toggle sidebar visibility
      if (isOpen) {
        sidebar.style.display = 'block';
        document.body.style.overflow = 'hidden';
      } else {
        sidebar.style.display = '';
        document.body.style.overflow = '';
      }
    });

    // Close filters on overlay click for mobile
    document.addEventListener('click', (e) => {
      if (sidebar.classList.contains('filters--open') &&
          !sidebar.contains(e.target) &&
          !toggleBtn.contains(e.target)) {
        sidebar.classList.remove('filters--open');
        sidebar.style.display = '';
        document.body.style.overflow = '';
        toggleBtn.setAttribute('aria-expanded', 'false');
      }
    });
  }

  /* ═══════════════════════════════════════
     COLLECTION SORT
     ═══════════════════════════════════════ */
  function initCollectionSort() {
    const sortSelect = $('[data-sort-select]');
    if (!sortSelect) return;

    sortSelect.addEventListener('change', () => {
      const url = new URL(window.location);
      url.searchParams.set('sort_by', sortSelect.value);
      window.location = url.toString();
    });
  }

  /* ═══════════════════════════════════════
     COLLECTION FILTERS
     ═══════════════════════════════════════ */
  function initCollectionFilters() {
    const filtersContainer = $('[data-collection-filters]');
    if (!filtersContainer) return;

    const checkboxes = $$('input[type="checkbox"]', filtersContainer);
    const priceInputs = $$('input[type="number"]', filtersContainer);

    const applyFilters = debounce(() => {
      const url = new URL(window.location);
      // Clear existing filter params
      [...url.searchParams.keys()]
        .filter(k => k.startsWith('filter.'))
        .forEach(k => url.searchParams.delete(k));

      checkboxes.forEach(cb => {
        if (cb.checked) {
          url.searchParams.append(cb.name, cb.value);
        }
      });

      priceInputs.forEach(input => {
        if (input.value) {
          url.searchParams.set(input.name, input.value);
        }
      });

      window.location = url.toString();
    }, 500);

    checkboxes.forEach(cb => cb.addEventListener('change', applyFilters));
    priceInputs.forEach(input => input.addEventListener('change', applyFilters));
  }

  /* ═══════════════════════════════════════
     PRODUCT RECOMMENDATIONS
     ═══════════════════════════════════════ */
  function initProductRecommendations() {
    const container = $('[data-product-recommendations]');
    if (!container) return;

    const productId = container.dataset.productId;
    const limit = container.dataset.limit || 4;

    if (!productId) return;

    const url = `/recommendations/products.json?product_id=${productId}&limit=${limit}`;

    fetch(url)
      .then(r => r.json())
      .then(data => {
        if (data.products && data.products.length > 0) {
          // Fetch the section HTML instead for proper rendering
          const sectionUrl = `/recommendations/products?product_id=${productId}&limit=${limit}&section_id=main-product`;
          fetch(sectionUrl)
            .then(r => r.text())
            .then(html => {
              const parser = new DOMParser();
              const doc = parser.parseFromString(html, 'text/html');
              const newGrid = doc.querySelector('[data-product-recommendations]');
              if (newGrid) {
                container.innerHTML = newGrid.innerHTML;
              }
            });
        }
      })
      .catch(() => {});
  }

  /* ═══════════════════════════════════════
     BACK TO TOP
     ═══════════════════════════════════════ */
  function initBackToTop() {
    const btn = $('#back-to-top');
    if (!btn) return;

    window.addEventListener('scroll', () => {
      if (window.scrollY > 500) {
        btn.classList.add('visible');
      } else {
        btn.classList.remove('visible');
      }
    }, { passive: true });

    btn.addEventListener('click', () => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  /* ═══════════════════════════════════════
     SCROLL REVEAL ANIMATIONS
     ═══════════════════════════════════════ */
  function initScrollReveal() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });

    // Add scroll-reveal to section children
    const selectors = [
      '.product-card',
      '.sport-nav__tile',
      '.nivel-selector__card',
      '.experience__card',
      '.reviews__card',
      '.blog-preview__card',
      '.blog-card',
      '.contact-info-card',
      '.collection-list__card',
      '.experience__stat'
    ];

    $$(selectors.join(',')).forEach((el, i) => {
      el.classList.add('scroll-reveal');
      el.style.transitionDelay = `${(i % 4) * 0.1}s`;
      observer.observe(el);
    });
  }

  /* ═══════════════════════════════════════
     COUNTER ANIMATION (Experience stats)
     ═══════════════════════════════════════ */
  function initCounters() {
    const counters = $$('[data-counter]');
    if (counters.length === 0) return;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const el = entry.target;
          const target = el.dataset.counter;
          const numericPart = parseInt(target);

          if (!isNaN(numericPart)) {
            const suffix = target.replace(/[\d]/g, '');
            let current = 0;
            const increment = Math.ceil(numericPart / 60);
            const timer = setInterval(() => {
              current += increment;
              if (current >= numericPart) {
                current = numericPart;
                clearInterval(timer);
              }
              el.textContent = current + suffix;
            }, 25);
          }

          observer.unobserve(el);
        }
      });
    }, { threshold: 0.5 });

    counters.forEach(counter => observer.observe(counter));
  }

  /* ═══════════════════════════════════════
     BRAND CAROUSEL — Pause on hover
     ═══════════════════════════════════════ */
  function initBrandCarousel() {
    const tracks = $$('[data-brand-track]');
    tracks.forEach(track => {
      track.addEventListener('mouseenter', () => {
        track.style.animationPlayState = 'paused';
      });
      track.addEventListener('mouseleave', () => {
        track.style.animationPlayState = 'running';
      });
    });
  }

  /* ═══════════════════════════════════════
     CART PAGE — Quantity & Remove
     ═══════════════════════════════════════ */
  function initCartPage() {
    const cartForm = $('#cart-form');
    if (!cartForm) return;

    // Quantity buttons (data-action="increase/decrease" + data-key)
    $$('.qty-btn', cartForm).forEach(btn => {
      btn.addEventListener('click', () => {
        const key = btn.dataset.key;
        const input = btn.closest('.qty-selector')?.querySelector('.qty-val');
        if (!input || !key) return;
        const dir = btn.dataset.action === 'increase' ? 1 : -1;
        const newQty = Math.max(0, parseInt(input.value) + dir);
        input.value = newQty;
        btn.disabled = true;
        updateCartItem(key, newQty).then(() => window.location.reload());
      });
    });

    // Qty input direct change
    $$('.qty-val', cartForm).forEach(input => {
      input.addEventListener('change', () => {
        const key = input.name.replace('updates[', '').replace(']', '');
        const newQty = Math.max(0, parseInt(input.value) || 0);
        updateCartItem(key, newQty).then(() => window.location.reload());
      });
    });

    // Coupon code handler
    const couponBtn = $('#coupon-apply-btn');
    const couponInput = $('#coupon-input');
    if (couponBtn && couponInput) {
      couponBtn.addEventListener('click', () => {
        const code = couponInput.value.trim();
        if (!code) return;
        window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=/cart';
      });
      couponInput.addEventListener('keydown', (e) => {
        if (e.key === 'Enter') {
          e.preventDefault();
          couponBtn.click();
        }
      });
    }
  }

  /* ═══════════════════════════════════════
     PREDICTIVE SEARCH
     ═══════════════════════════════════════ */
  function initPredictiveSearch() {
    const searchInputs = $$('.search-overlay__input, .search-page__input');

    searchInputs.forEach(input => {
      input.addEventListener('input', debounce(() => {
        const query = input.value.trim();
        if (query.length < 3) return;

        fetch(`/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product,article,page&resources[limit]=4`)
          .then(r => r.json())
          .then(data => {
            // Can be expanded with predictive search UI
            // For now, basic console log of results
          })
          .catch(() => {});
      }, 300));
    });
  }

  /* ═══════════════════════════════════════
     ACCESSIBILITY
     ═══════════════════════════════════════ */
  function initAccessibility() {
    // Focus trap for modals
    document.addEventListener('keydown', (e) => {
      if (e.key !== 'Tab') return;

      const openModal = $('.cart-drawer.open, .mobile-menu.open, .search-overlay.open');
      if (!openModal) return;

      const focusable = $$('a, button, input, select, textarea, [tabindex]:not([tabindex="-1"])', openModal);
      if (focusable.length === 0) return;

      const first = focusable[0];
      const last = focusable[focusable.length - 1];

      if (e.shiftKey) {
        if (document.activeElement === first) {
          e.preventDefault();
          last.focus();
        }
      } else {
        if (document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }
    });
  }

  /* ═══════════════════════════════════════
     SHOPIFY SECTION RENDERING API
     ═══════════════════════════════════════ */
  function initSectionRenderingAPI() {
    // Listen for Shopify theme editor events
    document.addEventListener('shopify:section:load', (e) => {
      initAllComponents();
    });

    document.addEventListener('shopify:section:reorder', () => {
      initScrollReveal();
    });

    document.addEventListener('shopify:block:select', (e) => {
      const block = e.target;
      if (block) {
        block.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    });
  }

  /* ═══════════════════════════════════════
     INITIALIZE ALL
     ═══════════════════════════════════════ */
  function initAllComponents() {
    initAnnouncementBar();
    initHeader();
    initMegaMenuAccessibility();
    initMobileMenu();
    initSearch();
    initCartDrawer();
    initHeroTabs();
    initProductGallery();
    initVariantSelector();
    initQuantityBtns();
    initFilterTabs();
    initCollectionSort();
    initFiltersToggle();
    initCollectionFilters();
    initProductRecommendations();
    initBackToTop();
    initScrollReveal();
    initCounters();
    initBrandCarousel();
    initCartPage();
    initPredictiveSearch();
    initAccessibility();
    loadWishlistState();
    initSectionRenderingAPI();
  }

  /* ─── DOM READY ─── */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllComponents);
  } else {
    initAllComponents();
  }

})();
